var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"widget"},[_c('h2',{staticClass:"subtitle"},[_vm._v(" Account Navigation ")]),_c('ul',{staticClass:"list list-unstyled"},[(_vm.isLoggedIn)?_c('router-link',{attrs:{"to":"/profile","tag":"li"}},[_vm._v(" My Profile ")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }